import { useIsAccountAdmin } from '../hooks/useIsAccountAdmin';
import { useActiveLocation } from '../hooks/useActiveLocation';
import { SideMenuPageLayout } from '../components/SideMenuPageLayout/SideMenuPageLayout';
import type {
  PageSection,
  PageSectionGroup
} from '../components/SideMenuPageLayout/SideMenuPageLayout';
import ROUTES, {
  GLOBAL_SETTINGS_SEGMENTS,
  LOCATION_SETTINGS_SEGMENTS,
  locationPath
} from '../routes/routeConstants';

const toLabelKey = (segment: string): string => `settings-menu-${segment}`;

export const SettingsPage = () => {
  const isAccountAdmin = useIsAccountAdmin();
  const { activeLocationId } = useActiveLocation();

  const groups: PageSectionGroup[] = [];

  // Location settings carry the active location in their URL. Hidden until a
  // location resolves (auto-selected to the first accessible one).
  if (activeLocationId) {
    const locationSections: PageSection[] = LOCATION_SETTINGS_SEGMENTS.map((segment) => ({
      to: locationPath(activeLocationId, ROUTES.settings, segment),
      labelKey: toLabelKey(segment)
    }));
    groups.push({ labelKey: 'settings-group-location', sections: locationSections });
  }

  // Global (account) settings are account-admin only and live at flat /settings/*.
  if (isAccountAdmin) {
    const globalSections: PageSection[] = GLOBAL_SETTINGS_SEGMENTS.map((segment) => ({
      to: `/${ROUTES.settings}/${segment}`,
      labelKey: toLabelKey(segment)
    }));
    groups.push({ labelKey: 'settings-group-global', sections: globalSections });
  }

  return <SideMenuPageLayout headingKey="settings-header" groups={groups} />;
};
